import CarouselItem from './carouselItem';
import SimpleButton from './simpleButton';

export default class ItemCarousel extends Phaser.GameObjects.Image {
  /**
   *  A simple prefab (extended game object class), displaying a spinning
   *  Phaser 3 logo.
   *
   *  @extends Phaser
   */
  constructor(
    scene,
    bg,
    x,
    y,
    cWidth,
    cHeight,
    items,
    maxItems,
    padding,
    charScale,
    worldScale,
    itemScale
  ) {
    super(scene, x, y, bg);
    this.scene = scene;
    this.emitter = new Phaser.Events.EventEmitter();
    this.itemDefs = items;
    this.itemDefs.sort(() => Math.random() - 0.5);
    this.maxItems = maxItems;
    this.padding = padding;
    this.bg = scene.add.image(0, 0, bg);
    this.bg.setOrigin(0.5, 0.5);
    this.bg.setDepth(-4);
    this.displayHeight = cHeight - x;
    this.setDisplaySize(this.bg.displayWidth, cHeight);
    this.blocked = false;
    this.items = [];
    this.itemHolder = scene.add.group('items');
    this.charScale = charScale;
    this.worldScale = worldScale;
    this.itemScale = itemScale;
    this.setItems(scene);
  }

  setItems(scene) {
    this.index = 0;
    let padding = this.padding;
    let itemNum = this.maxItems + 1;
    let itemHeight = (this.displayHeight - this.padding / 2) / itemNum;
    let itemWidth = this.min(itemHeight, this.displayWidth);
    let x = this.x + itemWidth * 0.5;
    let initY = this.y; // this.displayHeight * 0.5 - itemHeight * (itemNum / 2) + itemHeight * 0.5;
    // this.bg.setDisplaySize(itemWidth + padding, itemHeight * this.maxItems);
    this.bg.setPosition(x, this.y + this.displayHeight * 0.5);

    let y = initY + itemHeight;
    for (var i = 0; i < this.maxItems; i++) {
      // let itemName = this.itemDefs[this.index + i].icon;
      let item = new CarouselItem(scene, x, y, '', this.worldScale, this.itemScale); // scene.add.image(itemX,itemY,itemName);
      // item.setOrigin(0.5, 0.5);
      item.setDisplaySize(itemWidth - padding, itemHeight - padding);
      item.emitter.on('touchUp', this.handleItemReleased, this);
      // item.setDepth(1);
      this.itemHolder.add(item);
      this.items.push(item);
      y += itemHeight;
    }

    let btnWidth = itemWidth - padding * 2;
    let btnHeight = itemHeight - padding * 2;
    this.upButton = new SimpleButton(
      scene,
      x,
      initY + padding * 3,
      'btnUp',
      () => {
        if (this.blocked === false) { this.handleUpPressed(); }
      });
    this.upButton.setDisplaySize(btnWidth, btnHeight);
    this.downButton = new SimpleButton(
      scene,
      x,
      y - padding * 2.5,
      'btnDown',
      () => {
        if (this.blocked === false) { this.handleDownPressed(); }
      });
    this.downButton.setDisplaySize(btnWidth, btnHeight);
    this.itemHeight = itemHeight;
    this.itemWidth = itemWidth;
    this.updateItems(0);
  }

  handleDownPressed() {
    this.updateItems(this.index + this.maxItems);
  }

  handleUpPressed() {
    this.updateItems(this.index - this.maxItems);
  }

  toggleBlocked(toggleOn) {
    this.blocked = toggleOn;
    for (let i = 0; i < this.items.length; i++) {
      this.items[i].blocked = this.blocked;
    }
  }

  updateItems(newIndex) {
    this.index = newIndex;
    for (var i = 0; i < this.maxItems; i++) {
      let idx = this.index + i;
      if (idx < this.itemDefs.length) {
        let itemData = this.itemDefs[this.index + i];
        let itemName = itemData.icon;
        this.items[i].updateItem(
          itemName,
          itemData.type === 'sprite',
          idx,
          this.itemWidth - this.padding,
          this.itemHeight - this.padding
        );
        this.items[i].alpha = 1;
        this.items[i].toggleInteractive(this.scene, true);
      } else {
        this.items[i].alpha = 0;
        this.items[i].toggleInteractive(this.scene, false);
      }
    }

    this.toggleButtons(
      newIndex - this.maxItems >= 0,
      newIndex + this.maxItems < this.itemDefs.length
    );
  }

  toggleButtons(up, down) {
    this.downButton.setInteractive(down);
    this.downButton.alpha = down ? 1 : 0;
    this.upButton.setInteractive(up);
    this.upButton.alpha = up ? 1 : 0;
  }

  handleItemReleased(pointer, item) {
    if (item.itemID < this.itemDefs.length) {
      this.emitter.emit('itemReleased', pointer, item);
    }
  }

  min(a, b) {
    if (a < b) {
      return a;
    } else {
      return b;
    }
  }

  destroy() {
    if (this.itemHolder.children !== undefined) {
      this.itemHolder.clear(true);
      this.itemHolder.destroy();
    }
    this.upButton.destroy();
    this.downButton.destroy();
    this.itemHolder = null;
    this.upButton = null;
    this.downButton = null;
    if (this.items != null) {
      for (var i = this.items.length - 1; i >= 0; i--) {
        this.items[i].destroy();
        this.items[i] = null;
      }
    }
    this.items = null;
    super.destroy();
  }
}
